const _ = require('lodash'); // HACK: Duck-type for Polygon instance


const isPolygon = maybe => maybe && maybe[0] && maybe[0][0] && typeof maybe[0][0][0] === 'number';

const compile = ({
  expression,
  resources
}) => {
  const convertPolygonQuery = currentExpression => {
    if (isPolygon(currentExpression)) {
      const name = `$polygon${Object.keys(resources).length + 1}`; // eslint-disable-next-line no-param-reassign

      resources[name] = {
        value: currentExpression,
        __type: 'polygon'
      };
      return `resources select ${name}.value`;
    }

    if (_.isArray(currentExpression)) return currentExpression.map(convertPolygonQuery);
    if (_.isObject(currentExpression)) return _.mapValues(currentExpression, convertPolygonQuery);
    return currentExpression;
  };

  return {
    resources,
    expression: convertPolygonQuery(expression)
  };
};

const getRawExpressionFromLists = ({
  include,
  exclude = []
}) => {
  const includeExpression = include.length === 1 ? include[0] : {
    union: include
  };
  if (!exclude.length) return includeExpression;
  return {
    excludeFromFirst: [includeExpression, ...exclude]
  };
};

const compileFromLists = ({
  include,
  exclude
}) => {
  const logic = {
    resources: {},
    expression: getRawExpressionFromLists({
      include,
      exclude
    })
  };
  return compile(logic);
};

module.exports = {
  compile,
  compileFromLists
};